import { reskinStyles } from 'core/components/theme/theme-variant';
const styles = (theme) => ({
  root: {
    cursor: 'pointer',
    height: 48,
    '&$hover:hover': {
      backgroundColor: theme.colorPalette.orange_50_op_10,
      ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50 })
    }
  },
  hover: {} // Don't remove, required for $hover to work above, it's ugly i know
});

export default styles;
